import { createWebPushTransport, type PushTransport } from '@esnafai/shared/push';
import { createContext, createElement, useContext, type ReactNode } from 'react';

// The app's one PushTransport (UI architecture §12): the browser's web push. It asks for permission only inside
// subscribe(), which the screens call from a tap (merchant screens §4.5). Tests inject createMemoryPushTransport().
export const pushTransport: PushTransport = createWebPushTransport();

const PushContext = createContext<PushTransport>(pushTransport);

export function PushProvider({
  transport = pushTransport,
  children,
}: {
  transport?: PushTransport;
  children: ReactNode;
}) {
  return createElement(PushContext, { value: transport }, children);
}

export function usePushTransport(): PushTransport {
  return useContext(PushContext);
}
